var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",style:({ backgroundImage: 'url(' + _vm.bg + ')' })},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title reveal-bottom"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"subTitle reveal-bottom"},[_vm._v(_vm._s(_vm.subTitle))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e4caae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/CustomerDetail/DetaiHeader.vue
// module id = null
// module chunks = 